import * as React from 'react'

type RecordsFilterProps = {
  value: string
  onChange: (value: string) => void
}

export default function RecordsFilter({ value, onChange }: RecordsFilterProps) {
  return (
    <div className="input-group">
      <input
        id="resources-records-filter"
        type="text"
        className="form-control"
        placeholder="Søg/opret..."
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
